import * as ReactGA from 'react-ga';

const isDevMode = () => window.location.href.startsWith("http://localhost:");
// const isDevMode = () => false;

let lastPath = ""

export const initialiseGA = () => {
    if (isDevMode()) return;

    const gaId = "UA-145863763-1"
    ReactGA.initialize(gaId);
    trackCurrentPath();
}

export const trackCurrentPath = () => {
    if (isDevMode()) return;

    // google analytics
    const url = document.location.pathname;
    if (url != lastPath) {
        ReactGA.pageview(url);
        console.log(url);
    }
    lastPath = url;

}
